// extracted by mini-css-extract-plugin
module.exports = {"root":"LayoutSettings_root__3fj8E","content":"LayoutSettings_content__3aaJ-"};